import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { Store } from 'redux';

import App from './App';

window.React = React;
window.ReactDOM = ReactDOM;

export function disableReactDevTools() {
  if (typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'object') {
    return;
  }

  for (const prop in window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
    if (prop === 'renderers') {
      window.__REACT_DEVTOOLS_GLOBAL_HOOK__[prop] = new Map();
    } else {
      window.__REACT_DEVTOOLS_GLOBAL_HOOK__[prop] =
        typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__[prop] === 'function'
          ? () => {}
          : null;
    }
  }
}
if (process.env.NODE_ENV === 'production') disableReactDevTools();

export default function appRenderer(store: Store<any>) {
  const container = document.getElementById('react-root');
  const root = createRoot(container!);
  root.render(<App store={store} />);
}
